import React from "react";
import { useLang } from "@/lib/i18n";
import { cn } from "@/lib/utils";

export const LanguageToggle = ({ dark = false }) => {
  const { lang, setLang } = useLang();
  const base = "px-2.5 py-1 text-xs font-semibold rounded-md transition-colors duration-150";
  return (
    <div
      data-testid="language-toggle"
      className={cn(
        "inline-flex items-center rounded-lg border p-0.5",
        dark ? "border-white/25 bg-black/30" : "border-border bg-secondary",
      )}
    >
      {["en", "bm"].map((l) => (
        <button
          key={l}
          type="button"
          data-testid={`language-toggle-${l}`}
          onClick={() => setLang(l)}
          className={cn(
            base,
            lang === l
              ? dark ? "bg-white text-slate-900" : "bg-card text-foreground shadow-sm"
              : dark ? "text-white/70" : "text-muted-foreground",
          )}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
